import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Aufgabe (Task) — a unit of work handed to one member, with a due date and a
 * done/cancelled end. Distinct from an Assignment (Zuweisung), which is the
 * invitation to record a process step: a task carries no process topology.
 */ export const TaskStatusSchema = z.enum([
    'open',
    'done',
    'cancelled'
]);
/** Who created the task: a signed-in member, or an app running for the tenant. */ export const TaskCreatedBySchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('user'),
        userId: z.string()
    }),
    z.object({
        kind: z.literal('app'),
        appId: z.string()
    })
]);
/**
 * Where the task comes from. An app source may name the record the task is
 * about (`ref`) and a link the assignee opens to act on it (`url`).
 */ export const TaskSourceSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('app'),
        appId: z.string(),
        ref: z.string().optional(),
        url: z.string().optional()
    }),
    z.object({
        kind: z.literal('manual')
    })
]);
/** The fields every creator — member or app — supplies for a new task. */ export const TaskInputSchema = z.object({
    title: z.string().trim().min(1).max(200),
    description: z.string().trim().max(2000).optional(),
    assigneeId: ObjectIdSchema,
    /** ISO 8601 instant by which the task is due. */ dueAt: z.iso.datetime({
        offset: true
    }).optional()
});
export const TaskSchema = z.object({
    _id: z.string(),
    title: z.string(),
    description: z.string().optional(),
    assigneeId: z.string(),
    createdBy: TaskCreatedBySchema,
    dueAt: z.string().optional(),
    status: TaskStatusSchema,
    source: TaskSourceSchema,
    completedAt: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string()
});
/**
 * A task as "Meine Aufgaben" lists it: the creator resolved to a label the
 * assignee recognises (a member's full name, or the app's id).
 */ export const TaskListItemSchema = TaskSchema.extend({
    createdByLabel: z.string()
});

//# sourceMappingURL=task.schema.js.map